<template>
  <el-steps :active="active" finish-status="success" align-center>
    <el-step
      class="font-title"
      v-for="(item, index) in stepList"
      :key="index"
      :title="item"
    ></el-step>
  </el-steps>
</template>

<script>
export default {
  props: {
    stepList: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="scss">
.el-step {
  display: flex;
  flex-direction: column;
  &__head {
    &.is-success {
      color: $color-primary;
      border-color: $color-primary;
    }
  }
  &__title {
    font-size: 14px;
    &.is-success {
      color: $color-primary;
    }
  }
}
</style>
